import { resolveUrl } from "../../../config/apiConfig";
import { isPspMode } from "../../../config/pspMode";

/**
 * `fetch` wrapper used by the API utils. In PSP mode, rewrites `url` to the
 * standalone (controlpanel) origin via `resolveUrl`. Credentials resolve to a
 * caller-supplied `init.credentials` when present; otherwise they default to
 * `"include"` in PSP mode (so PSP host cookies travel with the request) and are
 * left unset in standalone mode. The URL is unchanged in standalone mode and
 * `init` is otherwise forwarded as-is.
 */
export function apiFetch(url: string, init: RequestInit = {}): Promise<Response> {
  const credentials = init.credentials ?? (isPspMode() ? "include" : undefined);
  return fetch(resolveUrl(url), {
    ...init,
    ...(credentials ? { credentials } : {}),
  });
}
